<script setup lang="ts">
withDefaults(defineProps<{
  show: boolean
}>(), {
  show: false,
})

const emit = defineEmits<{
  (e: 'close'): void
}>()

const { t } = useI18n()
</script>

<template>
  <div>
    <SolModal
      id="modal-multi-account-auto-consumption"
      :is-open="show"
      :title="t('modal.multiAccountAutoConsumption.title')"
      :size="{ desktop: 'medium', mobile: 'full' }"
      class="overflow-auto"
      :action-primary-text="t('modal.multiAccountAutoConsumption.actionButton')"
      @close="emit('close')"
      @action:primary="emit('close')"
    >
      <div class="flex flex-col items-start gap-6">
        <span class="fonts-body-large-regular text-brand-primary-dark">
          {{ t('modal.multiAccountAutoConsumption.description') }}
        </span>

        <div
          class="flex flex-col md:system:flex-row justify-center items-stretch gap-4 w-full"
        >
          <div
            class="
              flex flex-col gap-4 flex-1 p-4
              bg-brand-secondary-light rounded-lg
              bg-opacity-intense
            "
          >
            <strong>{{ t('modal.multiAccountAutoConsumption.attentionTitle') }}</strong>
            {{ t('modal.multiAccountAutoConsumption.attentionMessage') }}
          </div>
        </div>
      </div>
    </SolModal>
  </div>
</template>
